const PRODUCT_ID = document?.querySelector('body').getAttribute('product-id');

if (PRODUCT_ID) {
  const ASSET_ID_BY_PRODUCT_ID = {
    //Active Products
    "8356084547751": "0f983ece-333a-42fe-85e7-fee36230f3ad", // Legacy Executive High-Back
    "6278774259879": "e6381bba-e370-40c6-993d-e899c270a2aa", // Balance Deluxe
    "6278774489255": "4bddbf3f-aa01-4b35-a0ea-ef6f1e76ffba", // Balance Basic
    "8516260135079": "d02d9d37-c045-499c-9ecb-50657c789592", // Palisades Conference Mid-Back
    "8516253515943": "a6942d81-cbe9-4744-ae06-53859f95fe32", // Palisades Conference Mesh-Back
    //Elementals Products
    "8554559373479": "0f983ece-333a-42fe-85e7-fee36230f3ad", // Legacy Executive High-Back
    "8554559635623": "e6381bba-e370-40c6-993d-e899c270a2aa", // Balance Deluxe
    "8554560028839": "4bddbf3f-aa01-4b35-a0ea-ef6f1e76ffba", // Balance Basic
    "8554560422055": "d02d9d37-c045-499c-9ecb-50657c789592", // Palisades Conference Mid-Back
    "8554560749735": "a6942d81-cbe9-4744-ae06-53859f95fe32", // Palisades Conference Mesh-Back
    // "8402301419698": "cd9f8b88-1d57-4db2-8bdf-19bef81d3164",
    // "8406257959090": "88cde236-28b1-4c04-ae66-bc25d5f57b9d",
    // "8406254190770": "4527ecf7-c9ec-4a8c-b378-4c699d9dbee1",
    // "8406257926322": "9ea733f9-4129-40d8-b952-7bdf1eee7566",
    // "8406253633714": "d07d77ca-6c2a-4fa6-8cbf-a26a7bfb130c",
    // "8406256025778": "1220fb2e-cb81-49bb-a9cc-14c2e3a135b0",
    // "8406254780594": "94ae84ea-26a4-44d1-9b95-bbf52be34f62",
    // "8406256615602": "67044f35-51bd-41b2-83e9-5342ae4ac755",
    // "8406257598642": "1d041d03-79a5-49cd-b135-87c4078ea8da",
    // "8406257729714": "d04c3789-a4ac-4a1f-911b-724d8d29e2c2",
    // "6071389225138": "b8cec1f9-0a19-44e1-9f75-b51460058948",
    // "8416383303858": "1d041d03-79a5-49cd-b135-87c4078ea8da",
    // "8415751471282": "88cde236-28b1-4c04-ae66-bc25d5f57b9d",
    // "8416621559986": "d07d77ca-6c2a-4fa6-8cbf-a26a7bfb130c",
    // "8416618545330": "d07d77ca-6c2a-4fa6-8cbf-a26a7bfb130c",
    // "8418445033650": "b8cec1f9-0a19-44e1-9f75-b51460058948",
  }

  const MAP_TABLE_ID_BY_PRODUCT_ID = {
    //Active Products 
    "8356084547751": "d8881934-7bc2-4290-afb2-e4dbe18f8346", // Legacy Executive High-Back
    "6278774259879": "8926a362-445b-4262-a607-95150e0d1cf6", // Balance Deluxe
    "6278774489255": "8926a362-445b-4262-a607-95150e0d1cf6", // Balance Basic
    "8516260135079": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mid-Back
    "8516253515943": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mesh-Back
    //Elementals Products
    "8554559373479": "d8881934-7bc2-4290-afb2-e4dbe18f8346", // Legacy Executive High-Back
    "8554559635623": "8926a362-445b-4262-a607-95150e0d1cf6", // Balance Deluxe
    "8554560028839": "8926a362-445b-4262-a607-95150e0d1cf6", // Balance Basic
    "8554560422055": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mid-Back
    "8554560749735": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mesh-Back
    
    // "8406252290226": "8926a362-445b-4262-a607-95150e0d1cf6",
    // "8406253633714": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8406256025778": "8b073661-5b5d-4ae3-a783-f3e717b8a02e",
    // "8406254780594": "df2e5714-780e-4518-adc1-8d13dea70f53",
    // "8406256615602": "df2e5714-780e-4518-adc1-8d13dea70f53",
    // "8406257336498": "d8881934-7bc2-4290-afb2-e4dbe18f8346",
    // "8406257598642": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8406257729714": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8406257762482": "96cacf14-b094-4098-acde-218a7119fcd6",
    // "8406257828018": "96cacf14-b094-4098-acde-218a7119fcd6",
    // "6071389225138": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8416383303858": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8415751471282": "f441c37a-fd2a-42c5-b98e-3173d5889ca3",
    // "8416621559986": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8416618545330": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8418445033650": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8418439987378": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee"
  }


  window.assetId = ASSET_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
  window.mapTableId = MAP_TABLE_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
}


